module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE4IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiM4ODhCOTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTkgOC41ODJsOS02LjZ2LS4xNzlDMTggLjY5OCAxNy4xMDUgMCAxNiAwSDJDLjg5NiAwIDAgLjY5OCAwIDEuODAzdi4xNzlsOSA2LjZ6bS41NzMgMi4wNGEuOTk1Ljk5NSAwIDAgMS0xLjE0NiAwTDAgNC40MjNWMTJhMiAyIDAgMCAwIDIgMmgxNGEyIDIgMCAwIDAgMi0yVjQuNDIzbC04LjQyNyA2LjE5OXoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mail.svg
// module id = +zzn
// module chunks = 0 180